module.exports = __webpack_public_path__ + "media/src/assets/Images/paperclip-2f80704a837481a3d16e998c7f81f136.svg";